/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_End_WorkoutInputs */

const en_us2_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End workout`)
};

const pt_br2_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar treino`)
};

const es_419_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar entrenamiento`)
};

const pt_pt2_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar treino`)
};

const fr_fr2_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer la séance`)
};

const de_de2_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training beenden`)
};

const it_it2_workout_end_workout = /** @type {(inputs: Workout_End_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina allenamento`)
};

/**
* | output |
* | --- |
* | "End workout" |
*
* @param {Workout_End_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_end_workout = /** @type {((inputs?: Workout_End_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_End_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_end_workout(inputs)
	if (locale === "es-419") return es_419_workout_end_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_end_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_end_workout(inputs)
	if (locale === "de-DE") return de_de2_workout_end_workout(inputs)
	if (locale === "it-IT") return it_it2_workout_end_workout(inputs)
	return en_us2_workout_end_workout(inputs)
});
export { workout_end_workout as "workout.end_workout" }